import { render, staticRenderFns } from "./AddAnimal.vue?vue&type=template&id=143e15f8&"
import script from "./AddAnimal.vue?vue&type=script&lang=js&"
export * from "./AddAnimal.vue?vue&type=script&lang=js&"
import style0 from "./AddAnimal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports